import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56936696"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-green-500 accepted"
}
const _hoisted_2 = { style: {"font-size":"1.25em"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Thí sinh phải thực hiện Xác nhận nhập học trực tuyến trên hệ thống trong thời hạn quy định của Bộ Giáo dục và Đào tạo (Trước 17h00 ngày 21/8/2026). ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://nhaphoc.utc.edu.vn",
  title: "Hồ sơ Nhập học Online | Đại học Giao thông vận tải"
}, "https://nhaphoc.utc.edu.vn", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Nhà trường khuyến khích thí sinh thực hiện việc Xác nhận nhập trên hệ thống của Bộ Giáo dục và Đào tạo, Khai báo và tạo hồ sơ sinh viên trên hệ thống của trường ĐH GTVT trước ngày 18/08/2026 để tránh hệ thống quá tải và rủi ro về mặt kỹ thuật. ", -1))
const _hoisted_6 = {
  key: 1,
  style: {"font-size":"1.25em","color":"#d13438"}
}

import { ref } from 'vue';


const __default__ = {
    name: "ThongBaoTrungTuyen",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: {}
  },
  setup(__props: any) {


const convertTotal = (total?: string) => {
    let tongDiem = "";
    if (total) {
        tongDiem = parseFloat(total).toFixed(2)
    }
    return tongDiem;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createTextVNode(" Chúc mừng Thí sinh: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.fullName), 1),
            _createTextVNode(", Số CCCD "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.identityNumber), 1),
            _createTextVNode(" đã trúng tuyển Đại học chính quy năm 2026 (Khóa 67) vào trường Đại học GTVT. ")
          ]),
          _createElementVNode("div", null, [
            _createTextVNode("Phương thức xét tuyển: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.type), 1)
          ]),
          _createElementVNode("div", null, [
            _createTextVNode("Tổ hợp xét tuyển: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.group), 1)
          ]),
          _createElementVNode("div", null, [
            _createTextVNode("Điểm xét tuyển: "),
            _createElementVNode("strong", null, _toDisplayString(convertTotal(_ctx.item.total) ?? ""), 1)
          ]),
          _createElementVNode("div", null, [
            _createTextVNode(" Mã ngành trúng tuyển "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.fieldCode), 1),
            _createTextVNode(", Tên ngành: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.fieldName), 1)
          ]),
          _createElementVNode("div", null, [
            _createTextVNode(" Thí sinh được nhà trường cấp mã sinh viên: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.code), 1)
          ]),
          _createElementVNode("div", null, [
            _createTextVNode(" Lớp sinh hoạt Công dân – Sinh viên: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.politicalActivitiesClass), 1)
          ]),
          _hoisted_3,
          _createElementVNode("div", null, [
            _createTextVNode(" Thí sinh được cấp tài khoản: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.account), 1),
            _createTextVNode(" - Mật khẩu: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.code), 1),
            _createTextVNode(" truy cập vào website "),
            _hoisted_4,
            _createTextVNode(" để được hướng dẫn và thực hiện các thủ tục nhập học theo quy định của trường Đại học Giao thông vận tải ")
          ]),
          _hoisted_5
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, " Thí sinh không trúng tuyển hoặc thông tin tra cứu không chính xác! "))
  ]))
}
}

})